const KEY = 'bkfc_paywall_return_to';

/** Same-origin paths only: `//host` and `/\host` are other origins to `location.assign`. */
export const safeReturnTo = value =>
  typeof value === 'string' && /^\/(?![/\\])/.test(value) ? value : null;

const storage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

/**
 * Where to go after a purchase on `/subscribe`. `?returnTo=` is persisted across the Adyen 3DS
 * redirect, which comes back with `?redirectResult=` (and the page then strips the query). A plain
 * visit with neither drops a stale value from an abandoned checkout.
 * @param {string} search `location.search`
 * @returns {string|null}
 */
export function readPaywallReturnTo(search) {
  const params = new URLSearchParams(search);
  const fromQuery = safeReturnTo(params.get('returnTo'));
  if (fromQuery) {
    storage()?.setItem(KEY, fromQuery);
    return fromQuery;
  }
  if (params.get('redirectResult')) {
    return safeReturnTo(storage()?.getItem(KEY));
  }
  storage()?.removeItem(KEY);
  return null;
}

export const clearPaywallReturnTo = () => storage()?.removeItem(KEY);
